import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { formalizedItemFromUrl } from '../utilities/window';

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const { locale } = formalizedItemFromUrl()

        const _request = request.clone({
            setHeaders: {
                'Accept-Language': locale
            }
        });

        return next.handle(_request);
    }
}